/**
 * 组件统一导出
 */
import { Question } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export { PermissionButton, TextButton } from './Permission';
export { AvatarDropdown, AvatarName, Question };
